export const removeTypename = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => removeTypename(item));
    }
    if (data !== null && typeof data === 'object') {
        const newObj = {};
        Object.keys(data).forEach(key => {
            if (key !== '__typename') {
                newObj[key] = removeTypename(data[key]);
            }
        });
        return newObj;
    }
    return data;
};